











































































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import CardCanvas from '@/layouts/card-canvas.vue'

/* Helpers */
import LocalStore from '@/helpers/localstore'
import ColorAssistant from '@/helpers/color-assistant'
import TextAssistant from '@/helpers/text-assistant'
import TypeAssistant from '@/helpers/type-assistant'
import RouteAssistant from '@/helpers/route-assistant'
import WorkflowsAssistant from '@/helpers/workflows-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IWorkflowForSelection } from '@/api/types/response.types'

/* API */
import WorkflowsAPI from '@/api/modules/workflows.api'

export default Vue.extend({
  name: 'WorkflowHome',

  metaInfo: {
    title: 'Workflows',
  },

  components: {
    CardCanvas,
  },

  data() {
    return {
      EEntities,
      ColorAssistant,
      TextAssistant,
      TypeAssistant,
      RouteAssistant,
      WorkflowsAssistant,
      isLoading: true,
      isCloning: false,
      workflows: [] as IWorkflowForSelection[],
      showCreateWorkflowDrawer: false,
      selectedEntityType: EEntities.PROJECTS,
    }
  },

  computed: {
    accountID(): number {
      return parseInt(this.$route.params.accountId, 10)
    },
    filteredWorkflows(): IWorkflowForSelection[] {
      return this.workflows.filter(
        w =>
          this.selectedEntityType === null ||
          w.entityTypeID ===
            TypeAssistant.getEntityTypeID(this.selectedEntityType),
      )
    },
  },

  async created() {
    this.isLoading = true
    this.selectedEntityType = LocalStore.workflowsShowMailboxesFirst
      ? EEntities.MAILBOXES
      : EEntities.PROJECTS

    await this.fetchWorkflows()
    this.isLoading = false
  },

  methods: {
    handleCreateWorkflow() {},
    async fetchWorkflows() {
      try {
        this.workflows = await WorkflowsAPI.get_ForSelection()
      } catch (error) {
        this.$error.emit(error)
      }
    },
    updateSelectedEntityType(entityType: EEntities) {
      this.selectedEntityType = entityType
      LocalStore.workflowsShowMailboxesFirst =
        this.selectedEntityType === EEntities.MAILBOXES
    },
    async cloneWorkflow(id: number) {
      try {
        this.isCloning = true
        const response = await WorkflowsAPI.post_Clone(id)
        RouteAssistant.goToWorkflowDetail(
          this.$router,
          this.$route.params.accountId,
          response.id,
        )
      } catch (err) {
        this.$error.emit(err, true)
      } finally {
        this.isCloning = false
      }
    },
  },
})
